// extracted by mini-css-extract-plugin
module.exports = {"modal":"ViewDeeplinkModal_modal__12p2-","deeplink":"ViewDeeplinkModal_deeplink__11GDg"};